// store/permissionsSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { loadPermissions } from './permissions-middleware';
import { Permission } from 'api/models/response/permissions';
import { logout } from '../auth/auth-middleware';

interface PermissionsState {
    permissionsList: Permission[];
    loading: boolean;
    error: string | null;
    permissionsLoaded?: boolean;
}

const initialState: PermissionsState = {
    permissionsList: [],
    loading: false,
    error: null,
    permissionsLoaded: false,
};

const permissionsSlice = createSlice({
    name: 'app/permissions',
    initialState,
    reducers: {
        resetPermissionsLoaded(state) {
            state.permissionsLoaded = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadPermissions.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.permissionsLoaded = false;
            })
            .addCase(loadPermissions.fulfilled, (state, action) => {
                state.loading = false;
                state.permissionsList = action.payload;
                state.permissionsLoaded = true;
            })
            .addCase(loadPermissions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
                state.permissionsLoaded = false;
            })
            .addCase(logout.fulfilled, () => initialState);
    },
});

export const { resetPermissionsLoaded } = permissionsSlice.actions;
export default permissionsSlice.reducer;
